import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';

export interface Canny {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  get: () => Observable<(method: string, params: any) => void>;
}

export const CANNY = new InjectionToken<Canny>('Canny');
